var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_17701)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 7C0.333008 5.14348 1.07051 3.36301 2.38326 2.05025C3.69602 0.737498 5.47649 0 7.33301 0C9.18952 0 10.97 0.737498 12.2828 2.05025C13.5955 3.36301 14.333 5.14348 14.333 7C14.333 8.85652 13.5955 10.637 12.2828 11.9497C10.97 13.2625 9.18952 14 7.33301 14C5.47649 14 3.69602 13.2625 2.38326 11.9497C1.07051 10.637 0.333008 8.85652 0.333008 7ZM6.93354 9.996L10.9637 4.95787L10.2357 4.37547L6.79914 8.66973L4.36501 6.6416L3.76767 7.3584L6.93354 9.996Z",
    fill: "#FFD233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_17701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxDone);
export default __webpack_public_path__ + "static/media/checkbox-done.29dd6acb7d5432801ec17c2237d72f15.svg";
export { ForwardRef as ReactComponent };